<template>
  <Modal
    v-model="_value"
    width="500"
    title="创建音视频文件上传任务"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="reqUploadAvFileToFtp" autoComplete="on" v-model="reqUploadAvFileToFtp"
          class="card-box login-form">
      <FormItem prop="ip">
        <label style="display: inline-block; width: 100px;">FTP服务器IP</label>
        <Input style="display: inline-block; width: 300px;" v-model="reqUploadAvFileToFtp.ftpServIp"
               placeholder="请输入视频数据IP">
        </Input>
      </FormItem>
      <FormItem prop="ip">
        <label style="display: inline-block; width: 100px;">FTP服务器端口</label>
        <InputNumber style="display: inline-block; width: 300px;" v-model="reqUploadAvFileToFtp.ftpServPort"
                     placeholder="请输入FTP服务器端口">
        </InputNumber>
      </FormItem>
      <FormItem prop="ip">
        <label style="display: inline-block; width: 100px;">FTP服务器用户名</label>
        <Input style="display: inline-block; width: 300px;" v-model="reqUploadAvFileToFtp.userName"
               placeholder="请输入FTP服务器用户名">
        </Input>
      </FormItem>
      <FormItem prop="ip">
        <label style="display: inline-block; width: 100px;">FTP服务器用户密码</label>
        <Input style="display: inline-block; width: 300px;" v-model="reqUploadAvFileToFtp.pwd"
               placeholder="请输入FTP服务器用户密码">
        </Input>
      </FormItem>
<!--      <FormItem prop="ip">-->
<!--        <label style="display: inline-block; width: 100px;">FTP服务器文件路径</label>-->
<!--        <Input style="display: inline-block; width: 300px;" v-model="reqUploadAvFileToFtp.filePath"-->
<!--               placeholder="请输入FTP服务器文件路径">-->
<!--        </Input>-->
<!--      </FormItem>-->
      <FormItem prop="channel">
        <label style="display: inline-block; width: 100px;">逻辑通道号</label>
        <InputNumber style="display: inline-block; width: 300px;" v-model="reqUploadAvFileToFtp.channel"
                     placeholder="请输入逻辑通道号">
        </InputNumber>
      </FormItem>
      <FormItem prop="channel">
        <label style="display: inline-block; width: 100px;">查询时间段</label>
        <DatePicker size="small" type="datetimerange" :start-date="new Date()" placement="bottom-end"
                    placeholder="定位时间范围" style="width: 400px;margin-right: 3px;" @on-change="timeChange"
                    v-model="dateFilter"></DatePicker>
      </FormItem>
      <FormItem prop="code">
        <label style="display: inline-block; width: 100px;">码流类型</label>
        <Select v-model="codeType">
          <Option value=0 key=0>主码流或子码流</Option>
          <Option value=1 key=1>主码流</Option>
          <Option value=2 key=2>子码流</Option>
        </Select>
      </FormItem>
      <FormItem prop="dataType">
        <label style="display: inline-block; width: 100px;">数据类型</label>
        <Select v-model="avType">
          <Option value=0 key=0>音频和视频</Option>
          <Option value=1 key=1>音频</Option>
          <Option value=2 key=2>视频</Option>
          <Option value=3 key=3>音频或视频</Option>
        </Select>
      </FormItem>
      <FormItem prop="dataType">
        <label style="display: inline-block; width: 100px;">存储器类型</label>
        <Select v-model="storeType">
          <Option value=0 key=0>主存储器或灾备存储器</Option>
          <Option value=1 key=1>主存储器</Option>
          <Option value=2 key=2>灾备存储器</Option>
        </Select>
      </FormItem>
      <Button type="primary" @click="onClean" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSend">发送</Button>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'makeavfileuploadrequesttaskmodal',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      dateFilter: [],

      reqUploadAvFileToFtp: {
        id: null,
        ftpServIp: '110.41.10.140',
        ftpServPort: 21,
        userName: 'avsrcuser',
        pwd: '^w4FXdwW',
        channel: 1,
        filePath: null,
        startDatetime: 0,
        endDatetime: 0,
        avType: 0,
        codeType: 2,
        storeType: 0
      },
      avType: '2',
      codeType: '0',
      storeType: '0'
    }
  },
  methods: {
    ...mapActions([]),
    // 每次获取传入的时间都是格式化时间，但绑定的time其实是中国标准时间吗
    timeChange (time1) {
      if (time1[1].slice(-8) === '00:00:00') {
        time1[1] = time1[1].slice(0, -8) + '23:59:59'
        // 由于this.time是标准日期，因此必须使用这样的语句
        this.dateFilter = time1
      }
    },
    visibleChange (val) {
      if (val) {
        this.reqUploadAvFileToFtp.id = this._initValue
      }
    },
    onClean () {
      this.avType = '2'
      this.codeType = '0'
      this.storeType = '0'
      this.reqUploadAvFileToFtp.ftpServIp = '110.41.10.140'
      this.reqUploadAvFileToFtp.ftpServPort = 21
      this.reqUploadAvFileToFtp.userName = 'avsrcuser'
      this.reqUploadAvFileToFtp.pwd = '^w4FXdwW'
      this.reqUploadAvFileToFtp.channel = 1
      this.reqUploadAvFileToFtp.filePath = null
      this.reqUploadAvFileToFtp.startDatetime = 0
      this.reqUploadAvFileToFtp.endDatetime = 0
      this.reqUploadAvFileToFtp.avType = parseInt(this.avType, 10)
      this.reqUploadAvFileToFtp.codeType = parseInt(this.codeType, 10)
      this.reqUploadAvFileToFtp.storeType = parseInt(this.storeType, 10)
    },
    onSend () {
      if (this.dateFilter.length == 0) {
        this.reqUploadAvFileToFtp.startDatetime = null
        this.reqUploadAvFileToFtp.endDatetime = null
        return
      }
      if (this.dateFilter[0] === '' || this.dateFilter[1] === '') {
        this.reqUploadAvFileToFtp.startDatetime = null
        this.reqUploadAvFileToFtp.endDatetime = null
        return
      }
      let startDate = this.dateFilter[0]
      let endDate = this.dateFilter[1]
      this.reqUploadAvFileToFtp.startDatetime = new Date(startDate).Format('yyyy-MM-dd hh:mm:ss')
      this.reqUploadAvFileToFtp.endDatetime = new Date(endDate).Format('yyyy-MM-dd hh:mm:ss')

      this.reqUploadAvFileToFtp.avType = parseInt(this.avType, 10)
      this.reqUploadAvFileToFtp.codeType = parseInt(this.codeType, 10)
      this.reqUploadAvFileToFtp.storeType = parseInt(this.storeType, 10)

      console.log(this.reqUploadAvFileToFtp)

      store.dispatch('AvFileUploadRequestTaskServ_MakeTask',
        { params: this.reqUploadAvFileToFtp }
      ).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
